import { render, staticRenderFns } from "./ViewResult.vue?vue&type=template&id=1b0f41e0&"
import script from "./ViewResult.vue?vue&type=script&lang=js&"
export * from "./ViewResult.vue?vue&type=script&lang=js&"
import style0 from "./ViewResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports